import React, { useEffect, useState } from 'react';
import { IonButton, IonCard, IonCardContent, IonCardHeader, IonCardTitle } from '@ionic/react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ProfilePublicDto } from '../api';
import useAstroApiClient from '../hooks/useAstroApiClient';
import './UserProfile.css';

interface UserProfileProps {
  userId: string;
  onBack: () => void;
}

const UserProfile: React.FC<UserProfileProps> = ({ userId, onBack }) => {
  const history = useHistory();
  const { t } = useTranslation();
  const api = useAstroApiClient();
  const [profile, setProfile] = useState<ProfilePublicDto | null>(null);
  const [isOwnProfile, setIsOwnProfile] = useState(false);
  const [isFollowing, setIsFollowing] = useState(false);

  useEffect(() => {
    const loadProfile = async () => {
      const data = await api.apiSocialProfile(userId);
      setProfile(data);
      setIsFollowing(!!data?.isFollowing);
    };

    const checkCurrentUser = async () => {
      const current = await api.apiUsersAuth();
      if (current?.id === userId) {
        setIsOwnProfile(true);
      } else {
        setIsOwnProfile(false);
      }
    };

    loadProfile();
    checkCurrentUser();
  }, [userId, api]);

  const handleFollow = async () => {
    try {
      await api.apiSocialFollowMePost(userId);
      setIsFollowing(true);
    } catch {
      // Ignore errors for now
    }
  };

  const handleUnfollow = async () => {
    try {
      await api.apiSocialFollowMeDelete(userId);
      setIsFollowing(false);
    } catch {
      // Ignore errors for now
    }
  };

  return (
    <div className="user-profile">
      <div className="profile-actions">
        <IonButton onClick={onBack}>{t('goBack')}</IonButton>
        {!isOwnProfile && (
          isFollowing ? (
            <IonButton onClick={handleUnfollow}>{t('unfollow')}</IonButton>
          ) : (
            <IonButton onClick={handleFollow}>{t('follow')}</IonButton>
          )
        )}
      </div>
      {profile && (
        <IonCard>
          <IonCardHeader>
            <IonCardTitle>{profile.displayName}</IonCardTitle>
          </IonCardHeader>
          <IonCardContent>
            <p>{profile.bio}</p>
            {isOwnProfile && (
              <IonButton onClick={() => history.push('/edit-profile')}>
                {t('edit')}
              </IonButton>
            )}
          </IonCardContent>
        </IonCard>
      )}
    </div>
  );
};

export default UserProfile;


